import type * as d3 from 'd3'

import type { ChartScales } from '@/features/bidding/types/bidLadder'

export function renderCenterLine(g: d3.Selection<SVGGElement, unknown, null, undefined>, scales: ChartScales) {
  const { xScale, chartHeight } = scales
  const centerX = xScale(0)

  // Crisp vertical line at zero - more prominent
  g.append('line')
    .attr('x1', centerX)
    .attr('x2', centerX)
    .attr('y1', 0)
    .attr('y2', chartHeight)
    .attr('stroke', '#6b7280')
    .attr('stroke-width', 1)
}
